export const APPLICATION_NAME = 'Digital Certificate';
